import { useQueryWithStore, GET_ONE } from 'react-admin';

export const useGameStatus = gameId =>
  useQueryWithStore({
    type: GET_ONE,
    resource: 'gameStatuses',
    payload: { id: gameId },
  })
